// extracted by mini-css-extract-plugin
export var button = "_47-0";
export var icon = "_47-1";